module.exports = __webpack_public_path__ + "img/nav_5.dccce8d4.png";